<template>
    <div class="page">
        <div class="error_404">
            <p><img src="../assets/images/error-404.png" /></p>
            <p class="error-text">哎呀，出错了！您访问的页面不存在......</p>
            <p class="error-btn" @click="handleLogin">
                <el-button type="primary">返回登录</el-button>
            </p>
        </div>
    </div>
</template>

<script>
import { clientName } from '../settings'

export default {
    name: 'Error404',

    data() {
        return {
            loginUrl: ''
        }
    },

    created() {
        this.getRedirectLoginUrl()
    },

    methods: {
        async getRedirectLoginUrl() {
            try {
                const { data } = await this.$api.getRedirectLoginUrl()
                if (!data?.meta?.success) throw new Error(data?.meta?.message)
                this.loginUrl = data.data
            }
            catch (err) {
                console.error('getRedirectLoginUrl', err)
                this.$message({
                    message: err.message || '获取登录地址出错，请重试！',
                    type: 'error'
                });
            }
        },

        handleLogin() {
            const href = `${this.loginUrl}?clientName=${clientName}`
            location.href = href
        }
    }
}
</script>

<style lang="scss" scoped>
.page {
    width: 100%;
    height: 100vh;
    min-height: 550px;
    overflow: hidden;
    background: #EFEFF1;
    display: flex;
    justify-content: center;
    align-items: center;
}
.error_404 {
    margin: 0 auto;
    text-align: center;

    .error-text {
        margin-top: 40px;
        font-size: 100px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
    }

    .error-btn {
        margin-top: 25px;

        .el-button {
            width: 120px;
            height: 36px;
            font-size: 16px;
        }
    }
}
</style>